/** 问题反馈帖附件图片上限，发布页和帖子转换提示共用。 */
export const MAX_FEEDBACK_IMAGES = 24;
